import React from 'react';
import classnames from 'classnames';

import { Picture } from 'formlabs-web-components/Media';

import Amount from './Amount';
import './ProductOptionControl.module.css';

export const ProductOptionListControl = ({ children }) => {
  return <ul styleName="list">{children}</ul>;
};

const ProductOptionControl = ({
  children,
  controlPosition = 'center', // center, top
  imageElement = null,
  imagePosition = 'top', // top, left
  imageUrl = null,
  isActive = false,
  hatTitle = null,
  name,
  onChange = null,
  onClick = null,
  title,
  type = 'checkbox', // checkbox, radio
  value,
  quantityOptions = null
}) => {
  const quantityConfig = {
    disabled: false,
    minQuantity: 0,
    onQuantityChange: null,
    quantity: 0,
    ...quantityOptions
  };

  const image = imageElement ? (
    imageElement
  ) : imageUrl ? (
    <Picture largeImage={imageUrl} lazyload={false} />
  ) : null;
  return (
    <li styleName={classnames('item', type, imagePosition)}>
      {hatTitle && <p styleName="hat">{hatTitle}</p>}
      <label>
        <input
          styleName="input"
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onClick={onClick}
          checked={isActive}
        />

        <div styleName={classnames('body', `control-${controlPosition}`)}>
          {imagePosition === 'left' && image}
          <div styleName="content">
            {imagePosition === 'top' && image}
            <span styleName="title">{title}</span>
            {children}
          </div>
          {quantityOptions && (
            <div styleName="quantity">
              <Amount
                disabled={quantityConfig.disabled}
                min={quantityConfig.minQuantity}
                onAmountChange={quantityConfig.onQuantityChange}
                defaultValue={quantityConfig.quantity}
                value={quantityConfig.quantity}
              />
            </div>
          )}
        </div>
      </label>
    </li>
  );
};

export default ProductOptionControl;
